<div style="max-width: 350px;">
    <mat-card-title class="dialog-header">{{ 'login.recuperarPassword' | translate }}</mat-card-title>

    <form [formGroup]="recuperarForm" style="margin-top: 10px;">
        <div class="login-sim-form">
                
            <div class="form-group">
                <label style="font-size: 12px;">{{ 'login.cedula' | translate }}<span>:</span></label>
                <input type="text" class="form-control" formControlName="cedula" placeholder="{{ 'login.cedulaPlaceholder' | translate }}" [ngClass]="{ 'is-invalid': recuperarForm.controls.cedula.errors }" (keyup.enter)="onSubmit(recuperarForm.value)">
                <div *ngIf="recuperarForm.controls.cedula.errors && recuperarForm.controls.cedula.touched" style="color: #dc3545;">
                    <span style="font-size: 14px;">{{ 'login.cedulaError' | translate }}</span>
                </div>
            </div>

            <div class="d-flex justify-content-center px-2">
                <h6 class="msg">{{ 'login.mensajeRecuperacion' | translate }}</h6>
            </div>

        </div>
    </form>

    <div class="login-sim-mj-botones" style="margin-top: 25px; margin-bottom: 10px;">
        <a href="javascript:void(0)" style="text-transform: capitalize;" (click)="onCancelar()" class="btn-medio-contenido mx-1">{{ 'login._cancelar' | translate }}</a>
        <a href="javascript:void(0)" style="text-transform: capitalize;" (click)="onSubmit(recuperarForm.value)" class="btn-alto-contenido mx-1" [attr.disabled]="recuperarForm.invalid">{{ 'login._recuperar' | translate }}</a>
        <div *ngIf="_isLoadingResult" class="d-flex justify-content-center row mt-3">
            <mat-spinner [diameter]="30"></mat-spinner>
            <span class="ml-2" style="font-size: 16px; margin-top: 7px;">{{ 'Main._cargando' | translate }}</span>
        </div>
    </div>
</div>